import React from 'react'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import { fontSize, fontsWeight } from '@/shahrzad-assets/shared-constants/fonts'
import { Link } from 'react-router-dom'
import { styled } from 'styled-components'
import { sharedPathes } from '@/shahrzad-assets/shared-routing/pathe'
import ShahrzadServices from '@/shahrzad-assets/shared_components/ShahrzadServices'
import { getAccessToken } from '@/shahrzad-assets/shared-constants/localstorage'

const SideBarSmallUp = ({ tiles }: any) => {
  return (
    <>
      <List>
        <li>
          <ServicesPadding>
            {getAccessToken() ? <ShahrzadServices tileData={tiles} /> : null}
          </ServicesPadding>
        </li>
        <li>
          <Link to={import.meta.env.VITE_MAIN_WEB_URL + sharedPathes.FAQ}>
            <ListRight>
              <span>سوالات متداول</span>
            </ListRight>
          </Link>
        </li>
        <li>
          <Link
            to={import.meta.env.VITE_MAIN_WEB_URL + sharedPathes.ABOUT_SHAHRZAD}
          >
            <ListRight>
              <span> درباره شهرزاد</span>
            </ListRight>
          </Link>
        </li>
      </List>
    </>
  )
}

export default SideBarSmallUp

const List = styled.ul`
  display: flex;
  align-items: center;
  li {
    font-size: ${fontSize.NORMAL};
    font-weight: ${fontsWeight.BOLD};
    padding: ${dimens.SPACING_S} ${dimens.SPACING_M};
    cursor: pointer;
    a {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
`

const ListRight = styled.div`
  display: flex;
  align-items: center;
  span {
    margin-right: ${dimens.SPACING_S};
  }
`
const ServicesPadding = styled.div`
  padding: ${dimens.SPACING_S} ${dimens.SPACING_XXXXXL}
    ${dimens.SPACING_S} 0;
`
